/**
 * 添加否定词表单弹窗
 * 限制: <110行
 */
import React from 'react';
import { Modal, Form, Input, Select, Row, Col } from 'antd';
import type { FormInstance } from 'antd';
import { NEGATIVE_TYPE_OPTIONS, NEGATIVE_REASON_OPTIONS, NEGATIVE_LEVEL_OPTIONS } from './types';


interface AddNegativeKeywordModalProps {
    visible: boolean;
    form: FormInstance;
    onOk: () => void;
    onCancel: () => void;
}

export const AddNegativeKeywordModal: React.FC<AddNegativeKeywordModalProps> = ({
    visible,
    form,
    onOk,
    onCancel,
}) => {
    return (
        <Modal
            title="添加否定词"
            open={visible}
            onOk={onOk}
            onCancel={onCancel}
            width={600}
        >
            <Form form={form} layout="vertical">
                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item
                            name="content"
                            label="否定内容"
                            rules={[{ required: true, message: '请输入否定内容' }]}
                            extra="输入要否定的关键词或ASIN，多个请换行分隔"
                        >
                            <Input.TextArea
                                placeholder="输入关键词或ASIN"
                                rows={3}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="negative_type"
                            label="否定类型"
                            initialValue="keyword_exact"
                            rules={[{ required: true }]}
                        >
                            <Select
                                options={Object.entries(NEGATIVE_TYPE_OPTIONS).map(([value, label]) => ({
                                    value,
                                    label,
                                }))}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="reason"
                            label="否定原因"
                            initialValue="irrelevant"
                        >
                            <Select
                                options={Object.entries(NEGATIVE_REASON_OPTIONS).map(([value, label]) => ({
                                    value,
                                    label,
                                }))}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="level"
                            label="否定级别"
                            initialValue="campaign"
                        >
                            <Select
                                options={Object.entries(NEGATIVE_LEVEL_OPTIONS).map(([value, label]) => ({
                                    value,
                                    label,
                                }))}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="campaign_name" label="Campaign名称">
                            <Input placeholder="可选" />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item name="notes" label="备注">
                            <Input.TextArea rows={2} placeholder="可选备注" />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default AddNegativeKeywordModal;
